import client from '../utils/client';
import { eventsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const eventService = {
  eventsList,
  addEvent,
  getEvent,
  updateEvent
}

function eventsList(pageID, perPage) {
  return client.get(eventsUrl + '?page=' + pageID + '&per_page=' + perPage)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addEvent(formDate) {
  return client.post(eventsUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getEvent(eventID) {
  return client.get(eventsUrl + '/' + eventID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateEvent(formDate) {
  return client.post(eventsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}


function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}